function fechaHoy() {
  const hoy = new Date()
  const mes = String(hoy.getMonth() + 1).padStart(2, '0')
  const dia = String(hoy.getDate()).padStart(2, '0')
  return `${hoy.getFullYear()}-${mes}-${dia}`
}

function normalizarFecha(valor) {
  if (!valor) return fechaHoy()
  if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) return valor

  const partes = String(valor).match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/)
  if (!partes) return fechaHoy()

  return `${partes[3]}-${partes[2].padStart(2, '0')}-${partes[1].padStart(2, '0')}`
}

const state = {
  // Datos del paciente
  paciente: {
    cedula: '',
    nombres: '',
    edad: '',
    fecha: fechaHoy()
  },
  // Datos del CIE-10
  cie10Seleccionado: {
    codigo: '',
    nombre: '',
    diagnostico: ''
  },
  // Datos de la receta
  signosAlarma: '',
  observaciones: '',
  medicamentos: [
    { cantidad: '', nombre: '', indicaciones: '' }
  ]
}

const mutations = {
  // Mutaciones para el paciente
  SET_PACIENTE(state, paciente) {
    state.paciente = { ...paciente }
  },
  
  // Mutaciones para el CIE-10
  SET_CIE10(state, cie10) {
    state.cie10Seleccionado = { ...cie10 }
  },
  
  // Mutaciones para signos de alarma
  SET_SIGNOS_ALARMA(state, signos) {
    state.signosAlarma = signos
  },
  
  // Mutaciones para observaciones
  SET_OBSERVACIONES(state, observaciones) {
    state.observaciones = observaciones
  },
  
  // Mutaciones para medicamentos
  SET_MEDICAMENTOS(state, medicamentos) {
    state.medicamentos = [...medicamentos]
  },
  
  ADD_MEDICAMENTO(state) {
    state.medicamentos.push({ cantidad: '', nombre: '', indicaciones: '' })
  },
  
  REMOVE_MEDICAMENTO(state, index) {
    state.medicamentos.splice(index, 1)
  },
  
  UPDATE_MEDICAMENTO(state, { index, field, value }) {
    if (state.medicamentos[index]) {
      state.medicamentos[index][field] = value
    }
  },
  
  // Limpiar todos los datos
  CLEAR_RECETA(state) {
    state.paciente = {
      cedula: '',
      nombres: '',
      edad: '',
      fecha: fechaHoy()
    }
    state.cie10Seleccionado = {
      codigo: '',
      nombre: '',
      diagnostico: ''
    }
    state.signosAlarma = ''
    state.observaciones = ''
    state.medicamentos = [
      { cantidad: '', nombre: '', indicaciones: '' }
    ]
  },
  
  // Cargar datos desde localStorage
  LOAD_FROM_STORAGE(state) {
    const savedData = localStorage.getItem('recetaData')
    if (savedData) {
      try {
        const data = JSON.parse(savedData)
        state.paciente = {
          ...state.paciente,
          ...(data.paciente || {}),
          fecha: normalizarFecha(data.paciente && data.paciente.fecha)
        }
        state.cie10Seleccionado = data.cie10Seleccionado || state.cie10Seleccionado
        state.signosAlarma = data.signosAlarma || ''
        state.observaciones = data.observaciones || ''
        state.medicamentos = data.medicamentos || [{ cantidad: '', nombre: '', indicaciones: '' }]
      } catch (error) {
        console.error('Error al cargar datos de receta:', error)
      }
    }
  },
  
  // Guardar datos en localStorage
  SAVE_TO_STORAGE(state) {
    const dataToSave = {
      paciente: state.paciente,
      cie10Seleccionado: state.cie10Seleccionado,
      signosAlarma: state.signosAlarma,
      observaciones: state.observaciones,
      medicamentos: state.medicamentos
    }
    localStorage.setItem('recetaData', JSON.stringify(dataToSave))
  }
}

const actions = {
  // Acciones para el paciente
  setPaciente({ commit }, paciente) {
    commit('SET_PACIENTE', paciente)
    commit('SAVE_TO_STORAGE')
  },

  setFecha({ commit, state }, fecha) {
    commit('SET_PACIENTE', {
      ...state.paciente,
      fecha: normalizarFecha(fecha)
    })
    commit('SAVE_TO_STORAGE')
  },
  
  // Acciones para el CIE-10
  setCie10({ commit }, cie10) {
    commit('SET_CIE10', cie10)
    commit('SAVE_TO_STORAGE')
  },
  
  // Acciones para signos de alarma
  setSignosAlarma({ commit }, signos) {
    commit('SET_SIGNOS_ALARMA', signos)
    commit('SAVE_TO_STORAGE')
  },
  
  // Acciones para observaciones
  setObservaciones({ commit }, observaciones) {
    commit('SET_OBSERVACIONES', observaciones)
    commit('SAVE_TO_STORAGE')
  },
  
  // Acciones para medicamentos
  setMedicamentos({ commit }, medicamentos) {
    commit('SET_MEDICAMENTOS', medicamentos)
    commit('SAVE_TO_STORAGE')
  },
  
  addMedicamento({ commit }) {
    commit('ADD_MEDICAMENTO')
    commit('SAVE_TO_STORAGE')
  },
  
  removeMedicamento({ commit }, index) {
    commit('REMOVE_MEDICAMENTO', index)
    commit('SAVE_TO_STORAGE')
  },
  
  updateMedicamento({ commit }, payload) {
    commit('UPDATE_MEDICAMENTO', payload)
    commit('SAVE_TO_STORAGE')
  },
  
  // Limpiar receta
  clearReceta({ commit }) {
    commit('CLEAR_RECETA')
    localStorage.removeItem('recetaData')
  },
  
  // Cargar datos al inicializar
  loadRecetaData({ commit }) {
    commit('LOAD_FROM_STORAGE')
  }
}

const getters = {
  // Getters para el paciente
  getPaciente: state => state.paciente,
  
  // Getters para el CIE-10
  getCie10: state => state.cie10Seleccionado,
  
  // Getters para signos de alarma
  getSignosAlarma: state => state.signosAlarma,
  
  // Getters para observaciones
  getObservaciones: state => state.observaciones,
  
  // Getters para medicamentos
  getMedicamentos: state => state.medicamentos,
  
  // Verificar si hay datos guardados
  hasSavedData: state => {
    return state.paciente.cedula !== '' || 
           state.cie10Seleccionado.codigo !== '' || 
           state.signosAlarma !== '' || 
           state.observaciones !== '' ||
           state.medicamentos.some(med => med.cantidad || med.nombre || med.indicaciones)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 